import { noop } from '@datadog/browser-core';
import { RumEventCategory } from '../types';
import { RumEventType } from '../typesV2';
import { LifeCycleEventType } from './lifeCycle';
export function trackEventCounts(lifeCycle, callback) {
    if (callback === void 0) { callback = noop; }
    var eventCounts = {
        errorCount: 0,
        longTaskCount: 0,
        resourceCount: 0,
        userActionCount: 0,
    };
    var subscription = lifeCycle.subscribe(LifeCycleEventType.RAW_RUM_EVENT_COLLECTED, function (_a) {
        var rawRumEvent = _a.rawRumEvent;
        switch (rawRumEvent.evt.category) {
            case RumEventCategory.ERROR:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case RumEventCategory.USER_ACTION:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case RumEventCategory.LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case RumEventCategory.RESOURCE:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    var subscriptionV2 = lifeCycle.subscribe(LifeCycleEventType.RAW_RUM_EVENT_V2_COLLECTED, function (_a) {
        var rawRumEvent = _a.rawRumEvent;
        switch (rawRumEvent.type) {
            case RumEventType.ERROR:
                eventCounts.errorCount += 1;
                callback(eventCounts);
                break;
            case RumEventType.ACTION:
                eventCounts.userActionCount += 1;
                callback(eventCounts);
                break;
            case RumEventType.LONG_TASK:
                eventCounts.longTaskCount += 1;
                callback(eventCounts);
                break;
            case RumEventType.RESOURCE:
                eventCounts.resourceCount += 1;
                callback(eventCounts);
                break;
        }
    });
    return {
        stop: function () {
            subscription.unsubscribe();
            subscriptionV2.unsubscribe();
        },
        eventCounts: eventCounts,
    };
}
//# sourceMappingURL=trackEventCounts.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@datadog/browser-rum/esm/domain/trackEventCounts.js
// module id = YPv0
// module chunks = 1